import { useState } from "react";
import type { SortState } from "./DataTableTypes";
import { nextSort } from "./rowSort";

export interface SortControl {
  sort: SortState | undefined;
  /** Cycles the column through ascending, descending and unsorted. */
  toggleSort: (key: string) => void;
}

export function useSortState(defaultSort: SortState | undefined): SortControl {
  const [sort, setSort] = useState<SortState | undefined>(defaultSort);
  return { sort, toggleSort: (key) => setSort((current) => nextSort(current, key)) };
}
